export default __webpack_public_path__ + "f8966ad1f4b96d00b033eb672ecdfe2a.png";